var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-link",
    {
      staticClass: "item",
      class: { hovered: _vm.hoveredValue == _vm.item.value },
      attrs: { tabindex: -1 },
      on: {
        click: function ($event) {
          return _vm.onClick()
        },
      },
    },
    [_vm._v(_vm._s(_vm.item.text))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }